// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { Permission, DefaultRoleConfigRequest } from '@/vue3/api/models';

export const usePermissionService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive
    const permissions = ref<Permission[]>([]);

    const accountPermissions = ref<Permission[]>([]);

    // methods
    const getAllPermission = async (): Promise<Permission[]> => {
        const res = await axios.get(`${apiUrl}/permission`);
        permissions.value = res.data;
        return res.data;
    };

    const getAllPermissionNameByAccountId = async (
        accountId: number,
    ): Promise<Permission[]> => {
        const res = await axios.get(
            `${apiUrl}/permission/account/${accountId}`,
        );
        accountPermissions.value = res.data;

        return res.data;
    };

    const getAllPermissionNameByAccountIdAndOrg = async (
        accountId: number,
    ): Promise<Permission[]> => {
        const res = await axios.get(
            `${apiUrl}/permission/account/temp/${accountId}`,
        );
        accountPermissions.value = res.data || [];

        return res.data;
    };

    const getPermission = async (id: number): Promise<Permission> => {
        const res = await axios.get(`${apiUrl}/permission/${id}`);
        return res.data;
    };

    const createPermission = async (
        permission: Permission,
    ): Promise<Permission> => {
        const res = await axios.post(`${apiUrl}/permission`, permission);
        return res.data;
    };

    const updatePermission = async (
        permission: Permission,
    ): Promise<Permission> => {
        const res = await axios.put(`${apiUrl}/permission`, permission);
        return res.data;
    };

    const deletePermission = async (id: number): Promise<Permission> => {
        const res = await axios.deleteId(`${apiUrl}/permission/${id}`);
        return res.data;
    };

    const getSignUpDefaultRoleConfig = async (): Promise<any> => {
        const res = await axios.get(`${apiUrl}/permission/default-account-sign-up-config`);
        return res.data;
    };

    const saveSignUpDefaultRoleConfig = async (
        payload: DefaultRoleConfigRequest,
    ): Promise<void> => {
        await axios.post(`${apiUrl}/permission/default-account-sign-up-config`, payload);
    };


    return {
        getAllPermission,
        getAllPermissionNameByAccountId,
        getAllPermissionNameByAccountIdAndOrg,
        getPermission,
        createPermission,
        updatePermission,
        deletePermission,
        permissions,
        accountPermissions,
        getSignUpDefaultRoleConfig,
        saveSignUpDefaultRoleConfig,
    };
};
